import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { PyrenzBlueButton } from '@client/theme';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onNext: () => void;
  onPrev: () => void;
}

export function Pagination({
  totalPages,
  currentPage,
  onNext,
  onPrev,
}: PaginationProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      mt={4}
      gap={4}
    >
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.2 }}
      >
        <PyrenzBlueButton
          onClick={onPrev}
          disabled={currentPage <= 1}
          startIcon={<ChevronLeftIcon />}
        >
          Previous
        </PyrenzBlueButton>
      </motion.div>

      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.2 }}
      >
        <PyrenzBlueButton
          onClick={onNext}
          disabled={currentPage >= totalPages}
          endIcon={<ChevronRightIcon />}
        >
          Next
        </PyrenzBlueButton>
      </motion.div>
    </Box>
  );
}
